<template>
    <div>
        <public-menu></public-menu>
        <public-nxzw></public-nxzw>
        <bottom-nav></bottom-nav>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Nxzw from "@/components/nxzw/Index"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../components/Footer.vue"
export default {
    components:{
        'public-menu': Public_menu,
        'public-nxzw': Nxzw,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
/* @import url('../../assets/css/zt.css'); */
</style>


// WEBPACK FOOTER //
// src/views/nxzw/Index.vue